import { styled } from 'leva/plugin';

export const StyledIcons = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '26px', // Set the width to 22px
  height: '26px', // Set the height to 22px
  padding: '6px', // Add some padding
  fontSize: '15px',
  color: '$highlight1',
  backgroundColor: '$elevation2', // Set the default background color
  transition: 'background-color 200ms ease', // Add a transition for the background color change
  '&:not(:disabled)': {
    color: '$highlight3',
    cursor: 'pointer',
    '&:hover': { // Add a hover effect
      backgroundColor: '$elevation3', // Darker background color on hover
    },
    $active: '$elevation1 $elevation3',
    $focus: '$elevation1 $elevation3',
  },
});
